/* eslint-disable react/require-default-props */
/* eslint-disable react/function-component-definition */
import React, { ButtonHTMLAttributes, useMemo, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type ButtonVariant =
  | "white"
  | "white-solid"
  | "success"
  | "primary"
  | "default"
  | "highlight"
  | "marketing"
  | "marketing-solid"
  | "green"
  | "green-solid"
  | "orange"
  | "blue"
  | "insurance"
  | "insurance-solid"
  | "danger"
  | "rainbow"
  | "rainbow-solid"
  | "purple"
  | "purple-solid"
  | "navyBlue"
  | "navyBlue-solid"
  | "highlight-solid";

interface CustomButtonProps extends Readonly<ButtonHTMLAttributes<HTMLButtonElement>> {
  variant?: ButtonVariant;
  gradient?: boolean;
  icon?: boolean;
  outline?: boolean;
  tooltip?: boolean;
  tooltipText?: string;
  tooltipPlacement?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  gradient,
  className,
  icon,
  outline,
  variant = "primary",
  tooltipText,
  tooltip,
  tooltipPlacement,
  ...buttonProps
}) => {
  const apendOutline = useMemo(() => (outline ? "outline-" : ""), [outline]);
  const iconClass = useMemo(() => (icon ? "btn-icon" : ""), [icon]);
  const variantClass = useMemo(() => (variant ? `btn-${apendOutline}${variant}` : ""), [variant, apendOutline]);
  const [showTooltip, setShowTooltip] = useState(false);

  // FOR GRADIENT TYPE BUTTON
  if (gradient) {
    return (
      <button type="button" className={`btn btn-gradient ${iconClass} ${variantClass} ${className ?? ""}`} {...buttonProps}>
        <span>{children}</span>
      </button>
    );
  }

  if (tooltip) {
    return (
      <OverlayTrigger overlay={<Tooltip id={`tooltip-${tooltipPlacement}`}>{tooltipText}</Tooltip>} show={showTooltip}>
        <button
          type="button"
          className={`btn ${iconClass} ${variantClass} ${className ?? ""}`}
          {...buttonProps}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {children}
        </button>
      </OverlayTrigger>
    );
  }

  // FOR FLAT COLOR TYPE BUTTON
  return (
    <button type="button" className={`btn ${iconClass} ${variantClass} ${className ?? ""}`} {...buttonProps}>
      {children}
    </button>
  );
};

export default CustomButton;
